<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("Orders.orderDetails") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- ==== Start:: Status Badges ==== -->
          <div class="badges_wrapper d-flex justify-content-between">
            <h4>
              {{ $t("PLACEHOLDERS.order_data") }}
            </h4>
            <div class="wrapper d-flex gap-3">
              <v-chip class="text-bg-primary" v-if="salonType === 'freelancer'">
                {{
                  $t("Orders.startTime", {
                    time: start_time,
                  })
                }}
              </v-chip>
              <v-chip
                class="bg-success text-white px-6"
                v-if="data.status_enum === 'new'"
              >
                {{ data.status }}
              </v-chip>
              <v-chip
                class="bg-primary text-white px-6"
                v-if="data.status_enum === 'in_progress'"
              >
                {{ data.status }}
              </v-chip>
              <v-chip
                class="bg-secondary text-white px-6"
                v-if="data.status_enum === 'finished'"
              >
                {{ data.status }}
              </v-chip>
              <v-chip
                class="bg-danger text-white px-6"
                v-if="data.status_enum === 'cancelled'"
              >
                {{ data.status }}
              </v-chip>
            </div>
          </div>
          <!-- ==== End:: Status Badges ==== -->

          <base-input
            col="3"
            type="text"
            :placeholder="$t('TABLES.Orders.orderNumber')"
            v-model.trim="data.id"
            disabled
          />
          <base-input
            col="5"
            type="text"
            :placeholder="$t('TABLES.Orders.orderDate')"
            v-model.trim="data.orderDate"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('TABLES.Orders.orderType')"
            v-model.trim="orderStatusText"
            disabled
          />
          <div v-if="data.reason">
            <hr class="w-75 mx-auto my-4" v-if="data.reason" />

            <h4 class="mt-4">{{ $t("Orders.cancel_reason") }}</h4>
            <base-input
              col="6"
              type="text"
              :placeholder="$t('Orders.reason')"
              v-model.trim="data.reason"
              disabled
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('Orders.reason_detail')"
              v-model.trim="data.reason_detail"
              disabled
            />
          </div>
          <hr class="w-75 mx-auto my-4" v-if="data.clientName" />
          <h4 class="mt-4">{{ $t("PLACEHOLDERS.client_data") }}</h4>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model.trim="data.clientName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientPhone')"
            v-model.trim="data.clientPhone"
            disabled
          />
          <div v-if="orderStatusText === $t('Orders.homeVisit')">
            <h5>{{ $t("Orders.clientAddress") }}</h5>
            <base-input
              v-if="data.detailsAddress?.client_address"
              col="12"
              type="text"
              :placeholder="$t('Orders.address')"
              v-model.trim="data.detailsAddress.client_address"
              disabled
            />
            <div class="map_wrapper mb-6">
              <GmapMap
                :center="{
                  lat: parseFloat(data.detailsAddress?.client_lat),
                  lng: parseFloat(data.detailsAddress?.client_lng),
                }"
                :zoom="13"
                map-type-id="terrain"
                style="width: 100%; height: 200px"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="false"
                  :draggable="false"
                  @click="center = m.position"
                />
              </GmapMap>
            </div>
          </div>
          <hr class="w-75 mx-auto my-4" />

          <h4 class="mt-4">{{ $t("Orders.providerData") }}</h4>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.providerName')"
            v-model.trim="data.storeName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.providerPhone')"
            v-model.trim="data.provider_phone"
            disabled
          />
          <div class="category_wrapper mb-3 row">
            <h5 v-if="data.mainCategory?.length > 0">
              {{ $t("Orders.main_category_name") }}
            </h5>
            <span
              v-for="cat in data.mainCategory"
              v-if="cat"
              class="col-2 mx-2 rounded mb-3 mt-2"
              :alt="$t('Orders.main_category_name')"
              >{{ cat.name }}</span
            >
          </div>
          <base-input
            col="12"
            type="text"
            :placeholder="$t('Orders.providerAddress')"
            v-model.trim="data.address.address"
            disabled
          />
          <hr class="w-75 mx-auto my-4" />
          <h4 class="mt-4">
            {{ $t("Orders.payment_data") }}
          </h4>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model.trim="payment_method"
            disabled
          />
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.TotalWithoutTax')"
            v-model.trim="data.TotalWithoutTax"
            disabled
          /> -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.tax')"
            v-model.trim="data.tax"
            disabled
          />
          <base-input
            v-if="data.coupon_discount_value > 0.0"
            col="6"
            type="text"
            :placeholder="$t('Orders.coupon_discount_value')"
            v-model.trim="data.coupon_discount_value"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.total_with_tax')"
            v-model.trim="data.total_with_tax"
            disabled
          />
          <base-input
            v-if="data.payment_method === 'installment'"
            col="6"
            type="text"
            :placeholder="$t('Orders.installment_fees')"
            v-model.trim="data.installment_fees"
            disabled
          />
          <base-input
            v-if="data.payment_method === 'installment'"
            col="6"
            type="text"
            :placeholder="$t('Orders.total_with_tax_with_installment')"
            v-model.trim="data.total_with_tax_with_installment"
            disabled
          />
          <base-input
            v-if="data.status_trans === 'home_visit'"
            col="6"
            type="text"
            :placeholder="$t('Orders.delivery_fees')"
            v-model.trim="data.delivery_fees"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.admin_profit')"
            v-model.trim="data.admin_profit"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.provider_profit')"
            v-model.trim="data.provider_profit"
            disabled
          />
          <hr class="w-75 mx-auto my-4" v-if="data.services?.length > 1" />
          <div style="display: flex; flex-direction: column; flex-wrap: wrap">
            <h4 v-if="data.services?.length > 0">
              {{ $t("Orders.services") }}
            </h4>
            <div
              style="display: flex; flex-wrap: wrap"
              v-for="service in data.services"
              :key="service.id"
            >
              <base-input
                col="3"
                type="text"
                :placeholder="$t('Orders.serviceName')"
                v-model="service.name"
                disabled
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('Orders.servicePrice')"
                v-model="service.price"
                disabled
              />
              <base-input
                v-if="service.start_time"
                col="3"
                type="text"
                :placeholder="$t('Orders.serviceStartTime')"
                v-model="service.start_time"
                disabled
              />
              <base-input
                col="3"
                type="text"
                :placeholder="$t('Orders.serviceDuration')"
                v-model="service.minutes"
                disabled
              />
            </div>
            <!-- <hr class="w-75 mx-auto my-4" v-if="data.services?.length > 1" /> -->
          </div>
          <hr class="w-75 mx-auto my-4" v-if="data.packages?.length > 1" />
          <div style="display: flex; flex-direction: column; flex-wrap: wrap">
            <h4 v-if="data.packages?.length > 0">
              {{ $t("Orders.packages") }}
            </h4>
            <div
              v-for="pack in data.packages"
              :key="pack.id"
              style="display: flex; flex-wrap: wrap"
            >
              <base-input
                col="6"
                type="text"
                :placeholder="$t('Orders.packageName')"
                v-model="pack.name"
                disabled
              />
              <base-input
                v-if="pack.start_time"
                col="6"
                type="text"
                :placeholder="$t('Orders.packageStartTime')"
                v-model="pack.start_time"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('Orders.packageDuration')"
                v-model="pack.minutes"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('Orders.packagePrice')"
                v-model="pack.price"
                disabled
              />
              <base-input
                v-if="pack.discount !== 0 && pack.discount !== null"
                col="6"
                type="text"
                :placeholder="$t('Orders.packagePriceAfterDiscount')"
                v-model="pack.price_after_discount"
                disabled
              />
              <div class="category_wrapper mb-3 row full-width">
                <h5 v-if="pack.services?.length > 0">
                  {{ $t("Orders.packageServices") }}
                </h5>
                <span
                  v-for="service in pack.services"
                  v-if="service"
                  class="col-2 mx-2 rounded mb-3 mt-2"
                  :alt="$t('Orders.main_category_name')"
                  >{{ service.name }}</span
                >
              </div>
            </div>
            <hr class="w-75 mx-auto my-4" v-if="data.packages > 1" />
          </div>
          <!-- End:: count_stores Input -->
        </div>
        <hr class="w-75 mx-auto my-4" v-if="data.rates.id !== null" />
        <div v-if="data.rates.id !== null">
          <h4 class="mt-4">
            {{ $t("Orders.rates") }}
          </h4>
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('Orders.rate')"
            v-model.trim="data.rates.review"
            disabled
          /> -->
          <div class="px-5 mt-5 mb-3 d-flex align-items-center gap-3">
            <h5 class="my-5">{{ $t("Orders.rate") }}</h5>
            <p
              class="my-3"
              v-if="
                !isNaN(parseFloat(data.rates.review)) &&
                parseFloat(data.rates.review) > 0
              "
            >
              <i
                v-for="n in Math.floor(parseFloat(data.rates.review))"
                :key="n"
                class="fas fa-star fs-5"
                style="color: #ffc107"
              ></i>
            </p>
            <p v-else>{{ data.rates.review }}</p>
          </div>
          <base-input
            col="12"
            type="text"
            :placeholder="$t('Orders.rateComment')"
            v-model.trim="data.rates.comment"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
// import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "ShowOrders",
  // components: {
  //   UploadsPhotos,
  // },
  computed: {
    filteredOrderServices() {
      return this.data.orderServices
        ? this.data.orderServices.filter((service) => service)
        : [];
    },
    orderStatusText() {
      return this.data.status_trans === "salon_visit"
        ? this.$t("Orders.salonVisit")
        : this.$t("Orders.homeVisit");
    },
    payment_method() {
      return this.data.payment_method === "installment"
        ? this.$t("Orders.installment")
        : this.data.payment_method === "online"
        ? this.$t("Orders.online")
        : this.$t("Orders.wallet");
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        reason: null,
        reason_detail: null,
        receiving_methodKey: null,
        receiving_method: null,
        total_with_tax: null,
        provider_profit: null,
        all_profit_provider: null,
        services: [],
        packages: [],
        rates: {
          id: null,
          review: null,
          comment: null,
        },
        address: {
          address: null,
          lat: null,
          lng: null,
        },
        storeName: null,
        subCategory: null,
        mainCategory: null,
        order_additions: null,
        filePdf: null,
        deliveryCharge: null,
        payment_method: null,
        TotalWithoutTax: null,
        total_with_tax: null,
        coupon_discount_value: null,
        tax: null,
        admin_profit: null,
        provider_profit: null,
        total_with_tax_with_installment: null,
        installment_fees: null,
        service_price: null,
        additions_price: null,
        delivery_fees: null,
        provider_app_amount: null,
        provider_amount: null,
        estimate_time: null,
        pickup_date: null,
        order_type: null,
        order_type_trans: null,
        orderServices: [],
        changeOrderStatus: null,
        createdAt: null,
        orderDate: null,
        clientName: null,
        clientPhone: null,
        status: null,
        status_enum: null,
        provider_phone: null,
        area: null,
        id: null,
        image: null,
        detailsAddress: {
          client_address: null,
          client_lat: null,
          client_lng: null,
        },
        provider_name: null,
        laundry_name: null,
        logo: null,
        shop_name: null,
        vendor_name: null,
        phone: null,
        email: null,
        descAr: null,
        descFr: null,
        storeCat: null,
        commercial_register_image: null,
        preparation_time: null,
        work_hours: null,
        state: null,
        city: null,
        district: null,
        street: null,
        twoer: true,
        status_trans: null,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
        work_hours: [],
      },
      additionalImages: [],
      salonType: null,
      start_time: null,
      imageId: [],
      imgUrls: [],
      markers: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        console.log("order details", res);

        // Start:: Set Data
        this.data.id = res.data.data.data?.id;
        this.data.orderDate = res.data.data.data?.created_at;
        this.data.status_trans = res.data.data.data?.order_type;
        this.data.status = res.data.data.data?.status;
        this.data.status_enum = res.data.data.data?.status_enum;
        this.data.clientName = res.data.data.data?.client?.name;
        this.data.clientPhone = res.data.data.data?.client?.mobile;
        this.data.detailsAddress = res.data.data.data?.address;
        this.data.storeName = res.data.data.data?.salon?.name;
        this.data.provider_phone = res.data.data.data?.salon?.mobile;
        this.data.address = res.data.data.data?.salon?.location;
        this.data.mainCategory = res.data.data.data?.salon?.categories;
        this.salonType = res.data.data.data?.salon?.type;
        this.start_time = res.data.data.data?.start_time;
        this.markers = [
          {
            id: 1,
            position: {
              lat: parseFloat(res.data.data.data?.address?.client_lat),
              lng: parseFloat(res.data.data.data?.address?.client_lng),
            },
          },
        ];
        // Payments
        this.data.TotalWithoutTax = res.data.data.data?.payment_data?.total;
        this.data.total_with_tax =
          res.data.data.data?.payment_data?.total_products;
        this.data.delivery_fees =
          res.data.data.data?.payment_data?.delivery_fees;
        this.data.tax = res.data.data.data?.payment_data?.tax_ratio;
        this.data.payment_method =
          res.data.data.data?.payment_data?.payment_method;
        this.data.admin_profit = res.data.data.data?.payment_data?.commission;
        this.data.provider_profit =
          res.data.data.data?.payment_data?.provider_profit;
        this.data.installment_fees =
          res.data.data.data?.payment_data?.installment_fees;
        this.data.total_with_tax_with_installment =
          res.data.data.data?.payment_data?.total_after_discount;
        this.data.coupon_discount_value =
          res.data.data.data?.payment_data?.coupon_discount_value;
        // services and packages
        this.data.services = res.data.data.data?.services;
        this.data.packages = res.data.data.data?.packages;
        // rates
        this.data.rates = res.data.data.data?.rates;
        // reason
        this.data.reason = res.data.data.data?.cancel_data?.reason?.reason;
        this.data.reason_detail =
          res.data.data.data?.cancel_data?.cancel_reason;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
.category_wrapper > span {
  background: #b67071;
  text-align: center;
  font-size: medium;
  color: white;
  width: max-content;
  padding-inline: 20px;
}
.full-width {
  flex: 0 0 100%;
  max-width: 100%;
  margin-inline-start: 5px !important;
}
</style>
